











































import { computed, defineComponent, ref } from '@vue/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { SfTabs } from '@storefront-ui/vue';
import { PropType } from 'vue';
import { TabberType } from '~/types/solepro/PageBuilder';
import { GenericObjectType } from '~/utils/types';
import { getTagFromString } from '~/utils/solepro/functions';

export default defineComponent({
    name: "TabberFaqs",
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object as PropType<TabberType>,
            required: true
        }
    },
    components: {
        PageBuilderComponent,
        SfTabs
    },
    head() {
        let faqScript: { hid: string; type: string; json: any } | null = null;
        const content = this.content as GenericObjectType;
        try {
            const faqs = content.children.map(el => el.tabContent.filter(c => c.contentType == 'accordion')).flat().map(faq => faq.children).flat().map(el => {
                return {
                    "@type": "Question",
                    "name": el.title,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": el.content?.textContent
                    }
                }
            })
            faqScript = {
                hid: 'ld-faq',
                type: 'application/ld+json',
                json: {
                    "@context": "https://schema.org/",
                    "@type": "FAQPage",
                    "mainEntity": faqs
                }
            }
        } catch (e) {
            console.warn('Error geenrating FAQS')
        }


        return {
            script: faqScript ? [faqScript] : []
        }
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        content?.children.forEach((tab, index) => {
            content.children[index].tabId = index
            const tabHeader = tab.children[0].children.find(el => el.contentType == 'heading').DOMContent.outerHTML
            const tabTag = getTagFromString(tabHeader)
            content.children[index].tabName = tabHeader.replace(tabTag, 'span')
            content.children[index].tabTag = tabTag;
            content.children[index].tabContent = (tab.children[0].children.filter(el => el.contentType != 'heading')).map(el => { return { ...el, questionTag: 'h4' } })
        });
        const selectedTabIndex = ref(0);
        return {
            content,
            selectedTabIndex
        }
    },
    watch: {
        selectedTabIndex(index) {
            this.scrollSelectedIntoView(index);
        }
    },
    methods: {
        prevIndex(){
            const tmp = this.selectedTabIndex - 1;
             this.selectedTabIndex = tmp > -1 ? tmp : 0
        },
        nextIndex(){
            const tmp = this.selectedTabIndex + 1;
             this.selectedTabIndex = tmp < this.content.children.length ? tmp : this.content.children.length-1
        },
        scrollSelectedIntoView(index) {
            this.$nextTick(() => {
                const list = this.$refs.listElement as HTMLElement;
                const li = list?.children[index] as HTMLElement;
                li?.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
            });
        },
        focusNextTrigger(index) {
            const triggers = this.$el.querySelectorAll(".tab-trigger");
            const nextIndex = (index + 1) % triggers.length;
            (triggers[nextIndex] as HTMLElement).focus();
        },

        focusPreviousTrigger(index) {
            const triggers = this.$el.querySelectorAll(".tab-trigger");
            const prevIndex = (index - 1 + triggers.length) % triggers.length;
            (triggers[prevIndex] as HTMLElement).focus();
        },
        handleAccessibilityKeydown(e, index) {
            const isMobile = window.innerWidth <= 1024;

            switch (e.key) {
                case "ArrowLeft":
                    if (isMobile) break;
                    e.preventDefault();
                    this.focusPreviousTrigger(index);
                    break;
                case "ArrowRight":
                    if (isMobile) break;
                    e.preventDefault();
                    this.focusNextTrigger(index);
                    break;
            }
        }
    },
    mounted() {
        const triggers = this.$el.querySelectorAll(".tab-trigger");
        triggers.forEach((trigger, index) => {

            // Handle keyboard interactions
            trigger.addEventListener("keydown", (e) => {
                this.handleAccessibilityKeydown(e, index);
            });
        });

        try {
            (this.$refs.listElement as HTMLElement).setAttribute('aria-labelledby', this.$el.closest('div').querySelector('h2').id)
        } catch (e) { }
    }
})
